<script setup lang="ts">
import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { defineProps, inject, ref, defineModel, watch } from "vue";
import { DestinyMatrix, DestinyMatrixKeysEnum } from "@/types/destinyMatrix";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  matrix: DestinyMatrix | undefined;
  hasPremiumAccess: boolean;
}>();
const isOpen = defineModel<boolean>({ default: false });
const getDescription =
  inject<(key: DestinyMatrixKeysEnum) => Promise<never>>("getDescription");

const { t } = useI18n();

watch(
  () => props.matrix,
  () => (description.value = undefined)
);

const description = ref();

async function getData() {
  if (!props.hasPremiumAccess) {
    isOpen.value = false;
  }
  if (!description.value && props.matrix && getDescription) {
    description.value = await getDescription(
      DestinyMatrixKeysEnum.KARMA_AND_40_YEARS_TASKS
    );
  }
}
</script>

<template>
  <AccordionComponent
    type="white"
    @opened="getData"
    v-model="isOpen"
    :isBlocked="!hasPremiumAccess"
  >
    <template #title>
      {{
        t(
          "calculators.destiny-matrix.accordions.karma-and-40-years-tasks.title"
        )
      }}
    </template>
    <template #faq-content>
      <div v-if="description" class="flex flex-col gap-2">
        <div class="whitespace-pre-line">
          {{
            t(
              "calculators.destiny-matrix.accordions.karma-and-40-years-tasks.desc"
            )
          }}
        </div>
        <p class="text-xl font-bold pt-4">
          {{
            t(
              "calculators.destiny-matrix.accordions.karma-and-40-years-tasks.main-task-title",
              {
                value: matrix.r1.r,
              }
            )
          }}
        </p>
        <div class="whitespace-pre-line">
          {{ description["main_task"] }}
        </div>
        <div v-for="(desc, index) in description['make_before']" :key="index">
          <p class="text-xl font-bold pt-4">
            {{
              t(
                "calculators.destiny-matrix.accordions.karma-and-40-years-tasks.task-before-title",
                {
                  value: index,
                }
              )
            }}
          </p>
          <div class="whitespace-pre-line">
            {{ desc }}
          </div>
        </div>
      </div>
    </template>
    <template #collapse-text-btn>
      {{ t("calculators.destiny-matrix.accordions.collapse") }}
    </template>
  </AccordionComponent>
</template>
